import { FormikValues } from 'formik'

export interface ProposedTenantUser {
  firstName: string
  surname: string
  email: string
}

export interface ProposedTenantIssuer {
  name: string
  domain: string
}

export interface ProposedTenant {
  id: number
  domain: string
  customerId: string
  customerName: string
  abn: string
  segmentCode: string
  ratesheet: string
  status: string
  acceptanceStatus: string
  users: ProposedTenantUser[]
  issuers: ProposedTenantIssuer[]
}

export interface TenantFormValues extends FormikValues {
  name: string
  domain: string
  isDemo: boolean
  isTrial: boolean
  timezone: string
  customerId?: number
  currency: string
  backOfficeEmail: string
  tPlusNDays: number
  basisPointFee: number
  enforceSeparationOfDuties: boolean
  signOffCount: number
  segmentCode: string
  passwordExpiryMonths: number
  capitalBasisEnabled: boolean
  longTermComplianceOnly: boolean
}

export const updateTenantInitialData: TenantFormValues = {
  domain: '',
  name: '',
  timezone: '',
  segmentCode: '',
  backOfficeEmail: '',
  capitalBasisEnabled: false,
  longTermComplianceOnly: false,
  currency: '',
  passwordExpiryMonths: 3,
  enforceSeparationOfDuties: false,
  isDemo: false,
  tPlusNDays: 0,
  basisPointFee: 0,
  isTrial: false,
  signOffCount: 1,
}
